import { createEvent } from "effector";
const OnChangeSearchParamsEvt = () => {
    const onChangeSearchParamsEvt = createEvent("OnChangeSearchParamsEvt");
    onChangeSearchParamsEvt.watch(() => console.log("OnChangeSearchParamsEvt"));
    return onChangeSearchParamsEvt;
};
export default OnChangeSearchParamsEvt;
//# sourceMappingURL=OnChangeSearchParamsEvt.js.map